
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppIcon',
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    iconClass(): string {
      return `icon--${this.type}`;
    },
  },
});
